// import moment from 'moment-timezone';
import sfPagesApi from '@/api/sf-pages';
// import { formatDate, groupBy } from '../../lib/helper';

const SET_PAGES = 'SET_PAGES';
const EDIT_PAGE = 'EDIT_PAGE';
const DELETE_PAGE = 'DELETE_PAGE';
const APPEND_PAGES = 'APPEND_PAGES';
const APPEND_NEW_PAGE = 'APPEND_NEW_PAGE';
const SET_PAGE_INFO = 'SET_PAGE_INFO';

const state = {
	pages: [],
	pageInfo: {
		last_page: 1,
		current_page: 1,
		total_all_pages: 1,
	},
};

const getters = {
	pages: state => state.pages,
	pageInfo: state => state.pageInfo,
};

const mutations = {
	[SET_PAGES](state, pages) {
		state.pages = pages;
	},
	[SET_PAGE_INFO](state, info) {
		state.pageInfo = info;
	},
	[APPEND_PAGES](state, pages) {
		state.all = state.all.concat(pages);
	},
	[APPEND_NEW_PAGE](state, page) {
		const pages = state.pages;
		page._id = { $oid: page._id };
		pages.unshift(page);
		state.pages = pages;
	},
	[DELETE_PAGE](state, index) {
		state.pages.splice(index, 1);
	},
	[EDIT_PAGE](state, page) {
		const index = state.pages.findIndex(currpage => currpage._id.$oid === page._id.$oid);
		// console.log('index', index, page, state.pages);
		if (index !== -1) {
			state.pages[index] = page;
		}
	},


};

const actions = {
	getPages({ commit }, data) {
		const callback = (response) => {
			const pages = response.data.pages;
			const pageInfo = response.data.page_info;
			commit(SET_PAGES, pages);
			commit(SET_PAGE_INFO, pageInfo);

			if (data.callback) data.callback();
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			const pageInfo = {
				current_page: 1,
				last_page: 1,
				total_all_products: 0,
				total_products: 0,
				_id: null,
			};

			commit(SET_PAGE_INFO, pageInfo);

			if (data.callback) data.callback();
		};
		sfPagesApi.getPages(data.params, callback, errorCallback);
	},
	delete({ commit }, index) {
		commit(DELETE_PAGE, index);
	},
	updatePage({ commit }, contact) {
		commit(EDIT_PAGE, contact);
	},
	setAppendPage({ commit }, value) {
		commit(SET_PAGES, value);
	},
	setAppendNewPage({ commit }, value) {
		commit(APPEND_NEW_PAGE, value);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
